import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 px-6 py-[14px] whitespace-nowrap rounded-full text-base leading-5 font-bold font-skyBold transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default:
          'bg-neutral-almost-white text-primary-bright-blue  hover:bg-primary-dark-blue hover:text-neutral-almost-white disabled:bg-neutral-light-grey disabled:text-neutral-mid-grey',
        primary:
          'bg-primary-bright-blue text-neutral-almost-white  hover:bg-primary-dark-blue disabled:bg-neutral-light-grey disabled:text-neutral-mid-grey',
        secondary:
          'bg-transparent text-neutral-almost-white border-2 border-neutral-almost-white hover:bg-primary-dark-blue hover:border-primary-dark-blue disabled:border-neutral-light-grey disabled:text-neutral-light-grey',
        tertiary:
          'text-neutral-almost-white underline hover:text-primary-bright-blue disabled:text-neutral-light-grey',
      },
      size: {
        default: 'h-12',
        sm: 'h-[42px]',
        lg: 'h-[52px]',
        icon: 'size-10 p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

export const SmallTabStyle: string = cn(
  'data-[state=active]:bg-primary-bright-blue data-[state=active]:text-white',
  buttonVariants({
    variant: 'tertiary',
    className:
      'rounded-full h-[32px] min-w-[48px] text-xs font-markPro border-transparent text-white hover:text-white bg-transparent px-4 py-[4px] text-white no-underline',
  })
);
